const gtmLoginSuccess = () => {
    dataLayer.push({
        event: 'login',
        step: 'login_success',
        _clear: true,
    })
}

export default gtmLoginSuccess
